<template>
  <div class="shopActivity-container">
    <el-row type="flex" justify="end">
        <el-button
          @click="createDialogVisible = true"
          icon="el-icon-plus"
          type="primary"
          >新建分类
        </el-button>
    </el-row>    

    <common-table :data="categoryList">
      
      <el-table-column prop="cateName" align="center" label="类型名称"></el-table-column>
      <el-table-column prop="orderId" align="center" label="显示顺序"  width="200"></el-table-column>
      <el-table-column prop="name" align="center" label="设置人员"  width="200"></el-table-column>
      <el-table-column prop="rowTime" align="center" label="设置日期" width="200"></el-table-column>
            
      <el-table-column prop="target" align="center" label="操作" width="170">
        <template slot-scope="scope">
          <el-button type="primary" size="small" 
            @click.native.prevent="onItemEditClick(scope.row)" icon="el-icon-edit"
          ></el-button>

          <el-button type="danger" size="small"
             icon="el-icon-delete" @click="onItemDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </common-table>

    <edit-module-dialog :visible.sync="createDialogVisible"></edit-module-dialog>
    <edit-module-dialog :visible.sync="editDialogVisible" :form-extra="currentItem"></edit-module-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import EditModuleDialog from "@/views/System/Setting/Category/EditCategoryDialog";
import {categoryDelete} from "@/api/setting";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {dealDeleteOperation} from "@/utils/tools";
import { moduleDetail } from "@/api/setting";


export default {
  name: "Module",
  components: { CommonTable, EditModuleDialog}, //,ProductEditDialog
  computed: { ...mapGetters(["categoryList"]) },
  data() {
    return {
      createDialogVisible: false,
      editDialogVisible:false,
      currentItem: {},
    };
  },
  async created() {
    this.search();
  },
  methods: {
    async onItemEditClick(item) {
      // const {data} = await moduleDetail({userId: getToken(), moduleId: item.moduleId});
      // console.log("sourceItemOperation--------", data);
      // this.currentItem = data;

			this.currentItem = item;
			this.editDialogVisible = true;
    },

    async onItemDelete(item) {
      // console.log(item);
			await dealDeleteOperation({deletePromise: categoryDelete({userId: getToken(), cateId: item.cateId})});
			await this.search();
    },

    async search(){
      await this.$store.dispatch("setting/categoryList", {});
    }
  },
};
</script>

<style scoped>
</style>